import { render, staticRenderFns } from "./gameAnalysis.vue?vue&type=template&id=dae97cb2&scoped=true&"
import script from "./gameAnalysis.vue?vue&type=script&lang=js&"
export * from "./gameAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./gameAnalysis.vue?vue&type=style&index=0&id=dae97cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae97cb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VProgressCircular})
